export { ChampionFigure } from "./ChampionFigure"
export type { ChampionFigureProps, ChampionPose } from "./ChampionFigure"
